<!--<ul class=" prefab-publish-drodown">-->
    <!-- For enterprise profiles -->
<ng-container *ngIf="projectService.isPrefabType()" >
    <li title="{{locale.LABEL_PUBLISH_PREFAB_TEAM}}" *wmsFeature="preferences.project?.actions.build.publishPrefabToTeam">
        <a (click)="publishPrefabToTeam()" name="header-action-publish" title="{{locale.LABEL_PUBLISH_PREFAB_TEAM}}">
            <i class= "wm-icon wms wms-vcs-push"></i>
          <span class="menu-name">{{locale.LABEL_PUBLISH_TO_TEAM}}</span>
        </a>
    </li>
    <!-- For online profiles -->
    <li *ngIf="preferences.project?.actions.build.publishPrefabToWorkspace && !preferences.project?.actions.build.publishPrefabToTeam"
        [ngClass]="{'disabled' : projectEdnDetails.branchType === 'BRANCH'}"
        title="{{projectEdnDetails.branchType === 'BRANCH' ? locale.LABEL_PUBLISH_PREFAB_WORKSPACE_NOT_SUPPORTED : locale.LABEL_PUBLISH_PREFAB_WORKSPACE}}">
        <a (click)="publishPrefab('workspace')" name="header-action-publish"
            title="{{locale.LABEL_PUBLISH_PREFAB_WORKSPACE}}">
            <i class="wm-icon  wms wms-vcs-push"></i>
          <span class="menu-name">{{locale.LABEL_PUBLISH_TO_WORKSPACE}}</span>
        </a>
    </li>
    <!--Publish prefab to Project-->
    <li title="{{locale.LABEL_PUBLISH_PREFAB_PROJECT}}">
        <a (click)="publishPrefabToProject()" name="wm-header-publish-prefab-project" title="{{locale.LABEL_PUBLISH_PREFAB_PROJECT}}">
            <i class="wm-icon   wms wms-vcs-push"></i>
          <span class="menu-name">{{locale.LABEL_PUBLISH_PREFAB_PROJECT}}</span>
        </a>
    </li>
</ng-container>
<!--</ul>-->
